// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see TrustedDeviceLoadDevicesStartedEvent
 */
export var TrustedDeviceLoadDevicesStarted = function (_a) {
    var reason = _a.reason;
    return ({
        name: "TrustedDevice LoadDevices Started",
        parameters: {
            cdf_entity: "TrustedDevice",
            cdf_action: "LoadDevices",
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see TrustedDeviceLoadDevicesFinishedEvent
 */
export var TrustedDeviceLoadDevicesFinished = function (_a) {
    var status = _a.status, errorMessage = _a.errorMessage;
    return ({
        name: "TrustedDevice LoadDevices Finished",
        parameters: {
            cdf_entity: "TrustedDevice",
            cdf_action: "LoadDevices",
            status: status !== undefined && status !== null ? status.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_message: errorMessage !== undefined && errorMessage !== null ? errorMessage.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see TrustedDeviceViewAllEvent
 */
export var TrustedDeviceViewAll = function (_a) {
    var numberOfDevices = _a.numberOfDevices;
    return ({
        name: "TrustedDevice View All",
        parameters: {
            cdf_entity: "TrustedDevice",
            cdf_action: "View",
            number_of_devices: numberOfDevices !== undefined && numberOfDevices !== null ? numberOfDevices.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see TrustedDeviceViewDetailsEvent
 */
export var TrustedDeviceViewDetails = function (_a) {
    var isThisDevice = _a.isThisDevice, lastLoginDate = _a.lastLoginDate, type = _a.type, source = _a.source;
    return ({
        name: "TrustedDevice View Details",
        parameters: {
            cdf_entity: "TrustedDevice",
            cdf_action: "View",
            is_this_device: isThisDevice !== undefined && isThisDevice !== null ? isThisDevice.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            last_login_date: lastLoginDate !== undefined && lastLoginDate !== null ? lastLoginDate.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see TrustedDeviceViewHiddenEvent
 */
export var TrustedDeviceViewHidden = function (_a) {
    var lastLoginDate = _a.lastLoginDate;
    return ({
        name: "TrustedDevice View Hidden",
        parameters: {
            cdf_entity: "TrustedDevice",
            cdf_action: "View",
            last_login_date: lastLoginDate !== undefined && lastLoginDate !== null ? lastLoginDate.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see TrustedDeviceViewSelectUpsellEvent
 */
export var TrustedDeviceViewSelectUpsell = function (_a) {
    var type = _a.type;
    return ({
        name: "TrustedDevice View SelectUpsell",
        parameters: {
            cdf_entity: "TrustedDevice",
            cdf_action: "View",
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see TrustedDeviceRemoveSelectEvent
 */
export var TrustedDeviceRemoveSelect = function () { return ({
    name: "TrustedDevice Remove Select",
    parameters: {
        cdf_entity: "TrustedDevice",
        cdf_action: "Remove",
    }
}); };
/**
 * @see TrustedDeviceRemoveConfirmationEvent
 */
export var TrustedDeviceRemoveConfirmation = function (_a) {
    var removalSuccessCount = _a.removalSuccessCount, removalFailureCount = _a.removalFailureCount;
    return ({
        name: "TrustedDevice Remove Confirmation",
        parameters: {
            cdf_entity: "TrustedDevice",
            cdf_action: "Remove",
            removal_success_count: removalSuccessCount !== undefined && removalSuccessCount !== null ? removalSuccessCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            removal_failure_count: removalFailureCount !== undefined && removalFailureCount !== null ? removalFailureCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see TrustedDeviceRemoveRetryEvent
 */
export var TrustedDeviceRemoveRetry = function (_a) {
    var attemptCount = _a.attemptCount;
    return ({
        name: "TrustedDevice Remove Retry",
        parameters: {
            cdf_entity: "TrustedDevice",
            cdf_action: "Remove",
            attempt_count: attemptCount !== undefined && attemptCount !== null ? attemptCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
